export default 'msa-tenant-config'
